import { TASKS_EXPIRE_SOON_THRESHOLD_IN_HOURS } from '@configs';
import { Date } from '@type';

import {
  dateIsBeforeNow,
  getDateDiffFromNow,
  getDateDuration,
  getDateDurationDays,
  getDateDurationHours,
  getDateDurationMinutes,
  getDateDurationSeconds,
} from '../date';

export const isTaskExpiringSoon = (startDate: Date, endDate: Date) => {
  return (
    dateIsBeforeNow(startDate) &&
    getDateDiffFromNow(endDate) <
      TASKS_EXPIRE_SOON_THRESHOLD_IN_HOURS * 60 * 60 * 1000
  );
};

export const formatTaskTime = (date: Date): string | null => {
  if (dateIsBeforeNow(date)) return null;
  const duration = getDateDuration(getDateDiffFromNow(date));
  const seconds = getDateDurationSeconds(duration);
  const minutes = getDateDurationMinutes(duration);
  const hours = getDateDurationHours(duration);
  const days = getDateDurationDays(duration);

  if (days >= 1) return `${days}d`;
  if (hours >= 1) {
    const minutesPart = minutes > 0 ? ' ' + minutes + 'm' : '';
    return `${hours}h${minutesPart}`;
  }
  if (minutes >= 1) return `${minutes + (seconds > 0 ? 1 : 0)}m`;
  return `${seconds}s`;
};
